/*
 * Wholesale page sections (sections/cf-wholesale-*.liquid).
 *
 * 1. Language switch. Every text carries data-cf-en / data-cf-es (snippets/cf-wholesale-i18n.liquid).
 *    The page starts in the language from ?lng=es|en, else localStorage "cf-locale", else English,
 *    the same detection as the LB-036 winner. The "(para español haga clic aquí)" link switches
 *    in place and remembers the choice in localStorage "cf-locale".
 * 2. "See how tiered pricing works" opens the matching FAQ question and scrolls to it.
 *
 * Listeners are delegated from document, so sections added or re-rendered in the
 * theme editor keep working; shopify:section:load re-applies the current language.
 * Every section includes this file; the guard below makes it run once.
 */
(function () {
  if (window.cfWholesale) return;

  var STORAGE_KEY = 'cf-locale';
  var LOCALES = ['en', 'es'];
  var DEFAULT_LOCALE = 'en';

  /* "es", "ES", "es-MX" -> "es"; anything unsupported -> null */
  function normalize(value) {
    if (!value) return null;
    var base = String(value).trim().toLowerCase().split('-')[0];
    return LOCALES.indexOf(base) > -1 ? base : null;
  }

  function detectLocale() {
    var fromQuery = null;
    var fromStorage = null;
    try { fromQuery = new URLSearchParams(window.location.search).get('lng'); } catch (e) {}
    try { fromStorage = window.localStorage.getItem(STORAGE_KEY); } catch (e) {}
    return normalize(fromQuery) || normalize(fromStorage) || DEFAULT_LOCALE;
  }

  var current = detectLocale();

  /* Write the texts of one language into root (the document or one section). */
  function apply(locale, root) {
    var nodes = (root || document).querySelectorAll('[data-cf-en]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = el.getAttribute(locale === 'es' ? 'data-cf-es' : 'data-cf-en');
      var prop = el.getAttribute('data-cf-prop');
      if (prop === 'value') {
        if (el.value !== text) el.value = text;
      } else if (prop === 'alt') {
        el.setAttribute('alt', text);
      } else if (el.textContent !== text) {
        el.textContent = text;
      }
    }
  }

  function setLocale(locale) {
    current = normalize(locale) || DEFAULT_LOCALE;
    try { window.localStorage.setItem(STORAGE_KEY, current); } catch (e) {}
    apply(current);
  }

  /* Open a FAQ question (a <details>) and bring it into view. */
  function openQuestion(id) {
    var item = id && document.getElementById(id);
    if (!item || item.tagName !== 'DETAILS') return false;
    item.open = true;
    item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-cf-lang-toggle]')) {
      event.preventDefault();
      setLocale(current === 'es' ? 'en' : 'es');
      return;
    }

    var link = target.closest('[data-cf-faq-link]');
    if (link) {
      var id = (link.getAttribute('href') || '').replace(/^#/, '');
      if (openQuestion(id)) event.preventDefault();
    }
  });

  /* Theme editor: a re-rendered section comes back in English; give it the current language. */
  document.addEventListener('shopify:section:load', function (event) {
    if (current !== DEFAULT_LOCALE) apply(current, event.target);
  });
  /* Theme editor: selecting a FAQ question block opens it. */
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target && event.target.tagName === 'DETAILS') event.target.open = true;
  });

  function init() {
    if (current !== DEFAULT_LOCALE) apply(current);
    /* A link to #faq-tiered-pricing from elsewhere opens that question. */
    if (window.location.hash) openQuestion(window.location.hash.slice(1));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.cfWholesale = { setLocale: setLocale, getLocale: function () { return current; } };
})();
